import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button, Pagination } from 'react-bootstrap';
import Sidebar from '../../../../molecules/Sidebar/Sidebar';
import {
  fetchBuildingsInitAction,
  filterBuildingsInitAction,
  setSelectedBuildingAction,
  updateBuildingsFiltersAction,
} from '../../../../../actions/instances/buildings';
import DynastySelector from '../../../../atoms/DynastySelector/DynastySelector';
import CitySelector from '../../../../atoms/CitySelector/CItySelector';
import TagsSelector from '../../../../atoms/TagsSelector/TagsSelector';
import ListBase from '../../../../Organisms/ListBase/ListBase';
import ListItem from '../../../../molecules/ListItem/ListItem';
import Icon from '../../../../atoms/Icon/Icon';
import BuildingTypeSelector from '../../../../atoms/BuildingTypeSelector/BuildingTypeSelector';
import FullPageLoader from '../../../../atoms/FullPageLoader/FullPageLoader';
import InputControl from '../../../../atoms/InputControl/InputControl';
import { diffBetween, isFilterEqual } from '../../../../../helpers/arrayHelpers';
import './ListBuildings.scss';

const ListBuildings = () => {
  const {
    buildingsList,
    isLoadingBuildings,
    didLoadBuildings,
    mainFilters,
    filteredBuildings,
    isLoadingMainBuildings,
    currentPageInfo,
  } = useSelector(state => state.buildings);
  const dispatch = useDispatch();
  const history = useHistory();
  const [filters, setFilters] = useState(mainFilters);
  const [displayedBuildings, setDisplayedBuildings] = useState([]);
  const [localTimeout, setLocalTimeout] = useState();
  useEffect(() => {
    dispatch(filterBuildingsInitAction(filters));
  }, [filters]);
  if (!didLoadBuildings && !isLoadingBuildings) {
    dispatch(fetchBuildingsInitAction());
  }
  useEffect(() => {
    if (mainFilters && mainFilters.length > 0) {
      setDisplayedBuildings(filteredBuildings);
      setFilters(mainFilters);
    } else {
      setDisplayedBuildings(buildingsList);
    }
  }, [buildingsList, filteredBuildings, mainFilters]);
  useEffect(() => {
    if (filters.length === 0 && mainFilters.length !== 0) {
      dispatch(updateBuildingsFiltersAction([]));
    }
  }, [filters, mainFilters]);
  const extractImage = (building) => {
    const defaultImage = '/images/default.jpg';
    if (building.images === null) {
      return defaultImage;
    }
    if (building.images.length === 0) {
      return defaultImage;
    }
    return building.images[0].url;
  };
  return (
    <div className="components-page-content">
      <div className="row actions-container">
        <h4 className="mb-4">Buildings Filters</h4>
        <div className="filters">
          <div className="actions">
            <div className="filter-item">
              <BuildingTypeSelector
                isMulti
                onChanged={(val) => {
                  const change = diffBetween(filters, val);
                  let newFilters = [...filters];
                  change.added.forEach((x) => {
                    newFilters.push({
                      ...x.value,
                      type: 'type',
                    });
                  });
                  change.deleted.forEach((x) => {
                    newFilters = newFilters.filter(y => isFilterEqual(x.value, y.value));
                  });
                  change.changed.forEach((x) => {
                    newFilters.push({
                      ...x.newValue,
                      type: 'type',
                    });
                  });
                  setFilters(newFilters);
                  dispatch(updateBuildingsFiltersAction(newFilters));
                }}
                selectedId={filters.filter(x => x.type === 'type').map(x => x.value)}
              />
            </div>
            <div className="filter-item">
              <DynastySelector
                isMulti
                onChanged={(val) => {
                  const change = diffBetween(filters, val);
                  let newFilters = [...filters];
                  change.added.forEach((x) => {
                    newFilters.push({
                      ...x.value,
                      type: 'dynasty',
                    });
                  });
                  change.deleted.forEach((x) => {
                    newFilters = newFilters.filter(y => isFilterEqual(x.value, y.value));
                  });
                  change.changed.forEach((x) => {
                    newFilters.push({
                      ...x.newValue,
                      type: 'dynasty',
                    });
                  });
                  setFilters(newFilters);
                  dispatch(updateBuildingsFiltersAction(newFilters));
                }}
                selectedId={filters.filter(x => x.type === 'dynasty').map(x => x.value)}
              />
            </div>
            <div className="filter-item">
              <CitySelector
                isMulti
                onChanged={(val) => {
                  const change = diffBetween(filters, val);
                  let newFilters = [...filters];
                  change.added.forEach((x) => {
                    newFilters.push({
                      ...x.value,
                      type: 'city',
                    });
                  });
                  change.deleted.forEach((x) => {
                    newFilters = newFilters.filter(y => isFilterEqual(x.value, y.value));
                  });
                  change.changed.forEach((x) => {
                    newFilters.push({
                      ...x.newValue,
                      type: 'city',
                    });
                  });
                  setFilters(newFilters);
                  dispatch(updateBuildingsFiltersAction(newFilters));
                }}
                selectedId={filters.filter(x => x.type === 'city').map(x => x.value)}
              />
            </div>
            <div className="filter-item">
              <TagsSelector
                isMulti
                onChanged={(val) => {
                  const change = diffBetween(filters, val);
                  let newFilters = [...filters];
                  change.added.forEach((x) => {
                    newFilters.push({
                      ...x.value,
                      type: 'tag',
                    });
                  });
                  change.deleted.forEach((x) => {
                    newFilters = newFilters.filter(y => isFilterEqual(x.value, y.value));
                  });
                  change.changed.forEach((x) => {
                    newFilters.push({
                      ...x.newValue,
                      type: 'tag',
                    });
                  });
                  setFilters(newFilters);
                  dispatch(updateBuildingsFiltersAction(newFilters));
                }}
                selectedId={filters.filter(x => x.type === 'tag').map(x => x.value)}
              />
            </div>
            <div className="filter-item">
              <InputControl
                type="text"
                placeholder="search"
                value={filters.find(x => x.type === 'search') ? filters.find(x => x.type === 'search').value : undefined}
                onValueChanged={(e) => {
                  const newFilters = filters.filter(x => x.type !== 'search');
                  newFilters.push({
                    type: 'search',
                    value: e,
                    label: e,
                  });
                  clearTimeout(localTimeout);
                  setLocalTimeout(setTimeout(() => {
                    setFilters(newFilters);
                    dispatch(updateBuildingsFiltersAction(newFilters));
                  }, 300));
                }}
              />
            </div>
          </div>
          <Button variant="default" onClick={() => history.push('/buildings/create')}>
            <Icon icon="plus" color="#000" />
          </Button>
        </div>
      </div>
      <div className="row components-list">
        <div className="col-md-9">
          {(displayedBuildings && displayedBuildings.length > 0) && !isLoadingMainBuildings && (
            <ListBase>
              {displayedBuildings.map(building => (
                <ListItem
                  imgSrc={extractImage(building)}
                  name={building.name}
                  code={building.building_type.name}
                  dynasty={building.dynasty.name}
                  location={`${building.city.name}, ${building.city.country.name}`}
                  creationDate={building.created_at}
                  inReview={building.in_review}
                  onViewClicked={() => {
                    dispatch(setSelectedBuildingAction(building));
                    history.push('/buildings/view');
                  }}
                  onEditClicked={() => {
                    dispatch(setSelectedBuildingAction(building));
                    history.push('/buildings/edit');
                  }}
                />
              ))}
            </ListBase>
          )}
          {(displayedBuildings && displayedBuildings.length > 0) && !isLoadingMainBuildings && (
            <div className="pagination-container mt-4">
              <Pagination>
                <Pagination.Prev
                  disabled={currentPageInfo.current_page === 1}
                  onClick={() => {
                    let newPage = currentPageInfo.current_page - 1;
                    if (newPage <= 0) {
                      newPage = 1;
                    }
                    const newFilters = [
                      ...filters.filter(x => x.type !== 'page'),
                      {
                        type: 'page',
                        label: newPage,
                        value: newPage,
                      },
                    ];
                    setFilters(newFilters);
                    dispatch(updateBuildingsFiltersAction(newFilters));
                  }}
                />
                <Pagination.Item>
                  {currentPageInfo.current_page}
                </Pagination.Item>
                <Pagination.Next
                  disabled={
                    currentPageInfo.per_page * currentPageInfo.current_page >= currentPageInfo.total
                  }
                  onClick={() => {
                    const newFilters = [
                      ...filters.filter(x => x.type !== 'page'),
                      {
                        type: 'page',
                        label: currentPageInfo.current_page + 1,
                        value: currentPageInfo.current_page + 1,
                      },
                    ];
                    setFilters(newFilters);
                    dispatch(updateBuildingsFiltersAction(newFilters));
                  }}
                />
              </Pagination>
            </div>
          )}
          {isLoadingMainBuildings && (
            <FullPageLoader />
          )}
        </div>
        <div className="col-md-3 p-0">
          <Sidebar />
        </div>
      </div>
    </div>
  );
};

ListBuildings.propTypes = {

};

ListBuildings.defaultProps = {

};

export default ListBuildings;
